import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;
// multilang support v3


export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface NewsCategory {
  id: string;
  name: string;
  name_en: string | null;
  name_ko: string | null;
  name_zh: string | null;
  slug: string;
  created_at: string;
}

export interface NewsArticle {
  id: string;
  title: string;
  title_en: string | null;
  title_ko: string | null;
  title_zh: string | null;
  category_id: string | null;
  published_at: string;
  content: string | null;
  content_en: string | null;
  content_ko: string | null;
  content_zh: string | null;
  thumbnail_url: string | null;
  external_url: string | null;
  is_published: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
  category?: NewsCategory;
}

export interface NewsImage {
  id: string;
  article_id: string;
  url: string;
  alt_text: string | null;
  sort_order: number;
  created_at: string;
}
